import React from "react";
import { Redirect } from "react-router-dom";

import DashboardUtils from "../utils/DashboardUtils";
import { mainConfig } from "../pages/main/mainConfig";
import { pagesConfig } from "../pages/pagesConfig";

const routeConfigs = [...mainConfig, ...pagesConfig];

const routes = [
  ...DashboardUtils.generateRoutesFromConfigs(routeConfigs),
  {
    component: () => <Redirect to="/errors/error-404" />,
  },
];

export default routes;
